import { useState, useEffect } from "react";
import axios from "axios";
import { server } from "../server";

function Home() {
  const [prompt, setPrompt] = useState("");
  const [generatedImage, setGeneratedImage] = useState({ imageURL: "", id: "" });
  const [imageType, setImageType] = useState("WEBP");
  const [width, setWidth] = useState(512);
  const [height, setHeight] = useState(512);
  const [gallery, setGallery] = useState([
    // Replace with your actual gallery data
    {
      _id: "1",
      imageURL: "https://i.ibb.co/27GD8MNt/image-1742790221124.jpg",
      prompt: "a realistic 3d cartoon boy in a wonderland",
    },
    {
      _id: "2",
      imageURL: "https://i.ibb.co/tTGkXGCY/image-1742781314125.webp",
      prompt: "A serene landscape",
    },
    {
      _id: "3",
      imageURL: "https://i.ibb.co/bgBB8ZYh/image-1742781519506.webp",
      prompt: "A surprised cat",
    },
    // Add more images as needed
  ]);


  const [gallery2, setGallery2] = useState([
    // Replace with your actual gallery data
    {
      _id: "4",
      imageURL: "https://i.ibb.co/JFQfYVn1/image-1742781523998.webp",
      prompt: "kissing coupley",
    },
    {
      _id: "5",
      imageURL: "https://i.ibb.co/9k9RP1VB/image-1742781495707.webp",
      prompt: "hot sexy lady on bra",
    },
    {
      _id: "6",
      imageURL: "https://i.ibb.co/rK4jZzvF/image-1742781513998.jpg",
      prompt: "an angry dragon",
    },
    // Add more images as needed
  ]);


  // Infinite auto-scrolling horizontal div
  useEffect(() => {
    const scrollContainer = document.querySelector(".scroll-container");
    if (scrollContainer) {
      const scrollWidth = scrollContainer.scrollWidth;
      let scrollPosition = 0;

      const scroll = () => {
        scrollPosition += 1; // Adjust speed as needed
        if (scrollPosition >= scrollWidth / 2) {
          scrollPosition = 0;
        }
        scrollContainer.scrollLeft = scrollPosition;
        requestAnimationFrame(scroll);
      };

      scroll();
    }
  }, []);

  // Image carousel card
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImage2Index, setCurrentImage2Index] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % gallery.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [gallery.length]);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage2Index((prevIndex) => (prevIndex + 1) % gallery2.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [gallery2.length]);


  // Validate width and height
  const isValidDimension = (value) => {
    return value >= 128 && value <= 2048 && value % 64 === 0;
  };

  // Handle width change
  const handleWidthChange = (e) => {
    const value = parseInt(e.target.value);
    if (isValidDimension(value)) {
      setWidth(value);
    } else {
      alert("Width must be between 128 and 2048, in multiples of 64.");
    }
  };

  // Handle height change
  const handleHeightChange = (e) => {
    const value = parseInt(e.target.value);
    if (isValidDimension(value)) {
      setHeight(value);
    } else {
      alert("Height must be between 128 and 2048, in multiples of 64.");
    }
  };

  // Generate image
  const generateImage = async () => {
    if (!isValidDimension(width) || !isValidDimension(height)) {
      alert("Width and height must be between 128 and 2048, in multiples of 64.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${server}/images/generate`,
        { prompt, width, height, outputFormat: imageType },
        { headers: { Authorization: token } }
      );
      setGeneratedImage({ imageURL: data.imageURL, id: data._id }); // Store both URL and ID
    } catch (error) {
      console.error("Generation failed:", error.response?.data);
      alert(`Error: ${error.response?.data?.message || "Generation failed"}`);
    }
  };

  // Delete an image
  const deleteImage = async (id) => {
    try {
      const token = localStorage.getItem("token");
      console.log("Deleting image with ID:", id); // Debugging
      await axios.delete(`${server}/images/delete/${id}`, {
        headers: { Authorization: token },
      });
    } catch (error) {
      console.error("Error deleting image:", error.response?.data);
      alert(`Error: ${error.response?.data?.message || "Failed to delete image"}`);
    }
  };

  // Download an image
  const downloadImage = async (url) => {
    try {
      // Fetch the image as a blob
      const response = await fetch(url);
      const blob = await response.blob();

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `image_${Date.now()}.jpg`; // Set the filename
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading image:", error);
      alert("Failed to download image. Please try again.");
    }
  };

  // Share an image
  const shareImage = async (url) => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Check out this image!",
          url: url,
        });
      } else {
        // Fallback for browsers that don't support Web Share API
        alert("Sharing is not supported in your browser. Copy the URL manually.");
      }
    } catch (error) {
      console.error("Error sharing image:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 to-indigo-900 text-white p-5">
      {/* Centered Container */}
      <div className="max-w-4xl mx-auto">
        {/* Powerful Writeup */}
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold mb-4">
            Create Stunning AI-Generated Images
          </h1>
          <p className="text-lg text-gray-300">
            Transform your ideas into reality. Describe your vision, customize the settings, and let the AI work its magic!
          </p>
        </div>

        {/* Image Generation Form */}
        <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6 shadow-lg">
          {/* Textarea for Prompt */}
          <textarea
            className="w-full h-32 p-4 bg-transparent border border-white/20 rounded-lg text-white placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="Describe your vision... (e.g., 'A futuristic city at sunset')"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
          />

          {/* Image Type Selection */}
          <select
            className="w-full mt-4 p-2 bg-transparent border border-white/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            value={imageType}
            onChange={(e) => setImageType(e.target.value)}
          >
            <option value="WEBP">WEBP</option>
            <option value="JPEG">JPEG</option>
            <option value="PNG">PNG</option>
          </select>

          {/* Width and Height Inputs */}
          <div className="mt-4 grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-300">Width:</label>
              <input
                type="number"
                className="w-full p-2 bg-transparent border border-white/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={width}
                onChange={handleWidthChange}
                min="128"
                max="2048"
                step="64"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300">Height:</label>
              <input
                type="number"
                className="w-full p-2 bg-transparent border border-white/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={height}
                onChange={handleHeightChange}
                min="128"
                max="2048"
                step="64"
              />
            </div>
          </div>

          {/* Generate Button */}
          <button
            className="w-full mt-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-purple-700 hover:to-indigo-700 transition-all"
            onClick={generateImage}
          >
            Generate Image
          </button>
        </div>

        {/* Display Generated Image */}
        {generatedImage.imageURL && (
          <div className="mt-8 text-center">
            <img
              src={generatedImage.imageURL}
              alt="Generated"
              className="mx-auto rounded-lg shadow-lg"
            />
            {/* Action Buttons */}
            <div className="flex justify-center gap-4 mt-4">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-all"
                onClick={() => deleteImage(generatedImage.id)}
              >
                Delete
              </button>
              <button
                className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-all"
                onClick={() => downloadImage(generatedImage.imageURL)}
              >
                Download
              </button>
              <button
                className="bg-purple-500 text-white px-4 py-2 rounded-lg hover:bg-purple-600 transition-all"
                onClick={() => shareImage(generatedImage.imageURL)}
              >
                Share
              </button>
            </div>
            <p>{prompt}</p>
          </div>
        )}

        {/* Gallery */}
        <div className="min-h-screen bg-gradient-to-br from-purple-900 to-indigo-900 text-white p-5">
          {/* Captivating Write-Up */}
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold mb-4">Explore the Gallery</h1>
            <p className="text-lg text-gray-300">
              Immerse yourself in a world of creativity and inspiration. Discover stunning AI-generated images that push the boundaries of imagination.
            </p>
          </div>

          {/* Infinite Auto-Scrolling Horizontal Div */}
          <div className="overflow-hidden mb-12">
            <div className="scroll-container flex gap-4">
              {[...gallery, ...gallery].map((img, index) => (
                <div
                  key={`${img._id}-${index}`}
                  className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition-all"
                >
                  <img
                    src={img.imageURL}
                    alt={img.prompt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Image Carousel Card */}
          <div className="flex justify-center mb-12">
            <div className="w-96 h-96 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src={gallery[currentImageIndex].imageURL}
                alt={gallery[currentImageIndex].prompt}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-4">
                <p className="text-white text-lg font-semibold">
                  {gallery[currentImageIndex].prompt}
                </p>
              </div>
            </div>
          </div>         

        
         
          {/* Modern Card Design */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {gallery2.map((img) => (
              <div
                key={img._id}
                className="bg-white/10 backdrop-blur-lg rounded-lg p-6 shadow-lg transform hover:scale-105 transition-all"
              >
                <img
                  src={img.imageURL}
                  alt={img.prompt}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h2 className="text-xl font-bold mb-2">{img.prompt}</h2>
                <p className="text-gray-300">
                  A breathtaking creation that captures the essence of imagination.
                </p>
              </div>
            ))}
          </div>


          {/* Image Carousel Card 2 */}
          <div className="flex justify-center mt-12">
            <div className="w-96 h-96 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src={gallery2[currentImage2Index].imageURL}
                alt={gallery2[currentImage2Index].prompt}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-4">
                <p className="text-white text-lg font-semibold">
                  {gallery2[currentImage2Index].prompt}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Home;